import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 512 512",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m153.464119 298.41699c-11.312816-16.804791-25.916393-31.241559-42.915354-42.425156 16.998961-11.183596 31.602538-25.617098 42.915354-42.418622 11.309513 16.801524 25.91309 31.235026 42.908746 42.418622-16.995656 11.183597-31.599233 25.620365-42.908746 42.425156zm332.532045-67.722163h-205.084446c-56.167604 0-101.858299-45.168794-101.858299-100.694827h-51.171992c0 55.620754-45.6147029 100.714425-101.881427 100.714425v50.567884c56.2667241 0 101.881427 45.093671 101.881427 100.717691h51.171992c0-55.526033 45.690695-100.717691 101.858299-100.717691h31.182933v54.418778h51.171992v-54.418778h34.579421v100.717691h51.168688v-64.161964c0-20.188612 16.556227-36.555727 36.981412-36.555727z",
  fill: "#c5ab80",
  "fill-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }